<div class="font-body tracking-normal leading-normal">
  <nav class="background-color3 h-auto w-full fixed top-0 z-20 py-3 px-4">
    <div class="flex items-center justify-between">
      <div>
        <img *ngIf="isAuthenticated" class="w-12 h-12 cursor-pointer" src="assets/side-menu-logo.webp"
          alt="Algoworks Logo" (click)="routeToPages()">
        <img *ngIf="!isAuthenticated" class="w-12 h-12 cursor-pointer" src="assets/side-menu-logo.webp"
          alt="Algoworks Logo">
      </div>
      <div>
        <div class="relative inline-block" *ngIf="isAuthenticated">
          <button (clickOutside)="onClickedOutside($event)" (click)="toggleDropdownMenu()"
            class="flex items-center drop-button focus:outline-none" id="options-menu" aria-haspopup="true"
            aria-expanded="true">
            <p class="px-2 py-1 block text-white">{{userName}}</p>
            <img class="w-4 h-4" src="assets/dd.png" alt="dropdown">
          </button>
          <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg"
            [ngClass]="status ? 'hidden' : ''">
            <div class="rounded-md bg-white shadow-xs">
              <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                <form method="POST" action="#">
                  <button type="submit" class="px-2 py-1 block" role="menuitem" (click)="routeToChange()">
                    Change Password
                  </button>
                  <button type="submit" class="px-2 py-1 block" role="menuitem" (click)="signOut()">
                    Sign Out
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
